export default __webpack_public_path__ + "static/media/Boneharbor.f9d85187.jpg";